module.exports = __webpack_public_path__ + "img/16.12ee7154.png";